import React from "react";
import BreadCrumbs from "../UI/BreadCrumbs";
import Icons from "../Icons/Icons";
import { isSet } from "../../Utils/CommonFunctions";
import htmlToJson from 'html-to-json';

const BuilderHoc = ({children,breadCrumbs,styles,viewTypes,pageFrom,...props})=>{
    
    const toogleEditorHandler = async (type)=>{
        // console.log('thisProps',type,props.htmlContentItems);
         const htmlContentItems = props.htmlContentItems;
        let returnData = '';
        if(type=='MANUAL'){
            returnData = await props.convertAndCreateElementToHTML(htmlContentItems,returnData);
             console.log('BUILDER',returnData);
        }else{
            let dynamicContent = '<Root>'+isSet(htmlContentItems,'')+'</Root>';
            var promise = htmlToJson.parse(dynamicContent, {
                'HTML': function ($doc) {
                return $doc;
                }
            },function (err, result) {
                    // result.HTML[0].children.map((item)=>{
                    //     console.log(item.children);
                    //     let htmlElement = item.children;
                    //     htmlElement.push({...htmlElement});
                    // });
            });
            promise.done(function (result) {
                result.HTML[0].children.map((item)=>{
                    console.log('render...',props,item.children);
                     returnData =  item.children;
                    // props.setRenderData({
                    //     id:1,
                    //     name:'div',
                    //     type:'Body',
                    //     data:'',
                    //     children:item.children,
                    //     attributes:{style:{width:'100%',padding:'10px 10px 10px 10px'}}
                    //   });
                    // console.log('ItemChildren...',item.children);
                    // wthis.setState({htmlElement:item.children});
                })
            });
        }
        console.log('returnData',returnData);
        props.toogleEditorTypeHandler(type,returnData);
      }
    return(
        <>
        <BreadCrumbs 
            breadCrumbsList={breadCrumbs} >
            <div className="mode-device ml-2">
                <div className="selectgroup selectgroup-info">
                {[{svgIcon:'CodeIcon',label:'Manual Code',id:'MANUAL'},{svgIcon:'CodeIcon',label:'HTML Builder',id:'BUILDER'}]
                .map((type,typeIndex)=>{
                    return(
                    <label className="selectgroup-item" key={typeIndex}>
                         <input type="radio" name="customize_type" checked={props.editorType===type.id?true:false} onChange={()=>toogleEditorHandler(type.id)} className="selectgroup-input" />
                        <span className="nav-icon selectgroup-button">
                        {type.label}
                        </span>
                    </label>
                    )
                })}
            </div>
          </div>
          <div className="mode-device ml-auto">
                <div className="selectgroup selectgroup-info">
                {viewTypes.map((type,typeIndex)=>{
                    return(
                    <label className="selectgroup-item" key={typeIndex}>
                        <input type="radio" name="value"  className="selectgroup-input" />
                        <Icons iconType={type.svgIcon} />
                    </label>
                    )
                })}
            </div>
          </div>
        </BreadCrumbs>
         <div className="viewport" style={{...styles}}>
            {/* {(pageFrom==='Manual Window')?
                <></>
            : */}
            
       
        
        {children}
        </div>
        </>
    )
}

export default BuilderHoc;